
// @ts-nocheck
import { Vue, Component, Mixins, Prop } from 'vue-property-decorator'

@Component({})
export default class App extends Mixins(Vue) {
  @Prop({ default: 'Loading Error' }) message: string
}
